import { css, keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  40% {
    transform: scale(1.25);
    opacity: 0.6;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const favouriteCountPulse = css<{ $isUpdated: boolean }>`
  display: inline-block;

  ${({ $isUpdated }) =>
    $isUpdated &&
    css`
      animation: ${pulse} 400ms ease-out;
    `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
